export default [ '$httpProvider', function ($httpProvider) {
  const isBasketResponse = (response) => {
    return response.data === 'not_found'
      || response.data === 'expired';
  };

  $httpProvider.interceptors.push([
    '$rootScope', '$q', '$state', '$window', 'authService',
    function ($rootScope, $q, $state, $window, authService) {
      return {
        'responseError': function (response) {
          if (response.status === 500) {
            $state.go('500', {}, { location: false });
          }

          if (response.status === 404) {
            if (!isBasketResponse(response)) {
              $state.go('404', {}, { location: false });
            }
          }

          if (response.status === 403) {
            $state.go('403', {}, { location: false });
          }

          if (response.status === 401) {
            authService.logout();
          }

          return $q.reject(response);
        }
      };
    }
  ]);
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/error.broadcast.service.js